const AGENT_CACHE_KEY = "agent_pipeline_cache"
const INTERACTION_QUEUE_KEY = "queued_agent_interactions"

export interface AgentCachePayload {
  rows: unknown[]
  summary: unknown[]
}

function normalizeAgentCache(raw: unknown): AgentCachePayload {
  if (Array.isArray(raw)) {
    return {
      rows: raw,
      summary: [],
    }
  }

  if (raw && typeof raw === "object") {
    const payload = raw as { rows?: unknown[]; summary?: unknown[] }
    return {
      rows: Array.isArray(payload.rows) ? payload.rows : [],
      summary: Array.isArray(payload.summary) ? payload.summary : [],
    }
  }

  return {
    rows: [],
    summary: [],
  }
}

export function saveAgentCache(agentId: string, payload: unknown) {
  localStorage.setItem(`${AGENT_CACHE_KEY}:${agentId}`, JSON.stringify(payload))
}

export function loadAgentCache(agentId: string): AgentCachePayload {
  const raw = localStorage.getItem(`${AGENT_CACHE_KEY}:${agentId}`)
  return raw ? normalizeAgentCache(JSON.parse(raw)) : { rows: [], summary: [] }
}

export function queueInteractionSubmission(agentId: string, payload: Record<string, unknown>) {
  const raw = localStorage.getItem(INTERACTION_QUEUE_KEY)
  const queue = raw
    ? (JSON.parse(raw) as Array<{ agentId: string; payload: Record<string, unknown> }>)
    : []
  queue.push({ agentId, payload })
  localStorage.setItem(INTERACTION_QUEUE_KEY, JSON.stringify(queue))
}

export async function flushInteractionQueue(
  submitter: (agentId: string, payload: Record<string, unknown>) => Promise<unknown>,
) {
  const raw = localStorage.getItem(INTERACTION_QUEUE_KEY)
  const queue = raw
    ? (JSON.parse(raw) as Array<{ agentId: string; payload: Record<string, unknown> }>)
    : []
  const remaining: typeof queue = []

  for (const item of queue) {
    try {
      await submitter(item.agentId, item.payload)
    } catch {
      remaining.push(item)
    }
  }

  if (remaining.length === 0) {
    localStorage.removeItem(INTERACTION_QUEUE_KEY)
  } else {
    localStorage.setItem(INTERACTION_QUEUE_KEY, JSON.stringify(remaining))
  }
}
